/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoSociedad from 'Infotrack@Modelos/administracion/tipoSociedad/entidades/tipoSociedad';
import React from 'react';
import TipoSociedadCM from '../controladorModelo/tipoSociedadCM';
import { acciones, IEstadoTipoSociedad } from '../reductorTipoSociedad';
import TipoSociedadVista from '../vista/tablaTipoSociedadVista';

const tipoSociedadCM = new TipoSociedadCM();

const TableTipoSociedadCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tipoSociedads, setTipoSociedads] = React.useState<ITipoSociedad[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTipoSociedad>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTipoSociedad();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTipoSociedad = () => {
        manejadorIndicadorCargaGlobal(true);
        tipoSociedadCM.consultarTipoSociedad().then((tipoSociedads) => {
            setTipoSociedads(tipoSociedads);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTipoSociedad?: ITipoSociedad) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTipoSociedad, tipoFormulario } });
    };

    const confirmarEliminacion = (tipoSociedad: ITipoSociedad) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTipoSociedad(tipoSociedad),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarTipoSociedad = (tipoSociedad: ITipoSociedad) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tipoSociedadCM.eliminarTipoSociedad(tipoSociedad).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TipoSociedadVista
            tipoSociedads={tipoSociedads}
            cargarTipoSociedad={cargarTipoSociedad}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTipoSociedadCV;
